import { apiOrderSchedule } from './apiOrderSchedule'
import { apiOrders } from './apiOrders'
import { apiClientCarts } from './apiClientCarts'
import { apiOrderDays } from './apiOrderDays'

const apiOrdersGroup = {
	...apiOrderSchedule,
	...apiOrders,
	...apiClientCarts,
	...apiOrderDays,
}

export { apiOrdersGroup }
